<template>
  <div @click.stop.prevent="handleClick">
    <div class="row">
      <div class="col-12 col-xs-12 col-sm-9">
        <h3 class="txt--xl">
          {{ title }}
        </h3>
      </div>
      <div class="col-12 col-xs-12 col-sm-3">
        <button class="calculator__switcher" @click="switchLayout()">
          <span v-if="switchType == false">switch to ft, in</span>
          <span v-if="switchType == true">switch to cm</span>
        </button>
      </div>
    </div>
    <div class="row" v-if="description != ''">
      <div class="col-12 col-xs-12">
        <div v-html="description"></div>
      </div>
    </div>
    <div class="row" v-if="heightNotValid">
      <div class="col-12 col-xs-12">
        <span class="danger-text"> Are you sure? </span>
      </div>
    </div>
    <div class="row" :class="[{ hide: switchType == true }]">
      <div class="col-12 col-xs-6 col-sm-4">
        <label class="calculator__label" for="currentHeight-cm"
          >Centimetres</label
        >
        <InputNumberElement
          :decimal="false"
          v-model="cm"
          id="currentHeight-cm"
          label="Centimetres"
          min="0"
          @blur="cmToFtIn()"
          :step="1"
        />
      </div>
    </div>
    <div class="row" :class="[{ hide: switchType == false }]">
      <div class="col-12 col-xs-6 col-sm-4">
        <label class="calculator__label" for="currentHeight-ft">Feet</label>
        <InputNumberElement
          :decimal="false"
          v-model="ft"
          id="currentHeight-ft"
          label="Feet"
          min="0"
          @blur="ftInToCm()"
          :step="1"
        />
      </div>
      <div class="col-12 col-xs-6 col-sm-4">
        <label class="calculator__label" for="currentHeight-inches"
          >Inches (max 11)</label
        >
        <InputNumberElement
          :decimal="false"
          v-model="inches"
          id="currentHeight-inches"
          label="Inches"
          min="0"
          max="11"
          @blur="ftInToCm()"
          :step="1"
        />
      </div>
    </div>

    <hr class="mb-2 mb--2" />
  </div>
</template>

<script>
import InputNumberElement from "@/components/inputs/InputNumberElement";
export default {
  name: "InputHeight",
  components: {
    InputNumberElement,
  },
  props: {
    title: String,
    description: String,
    id: String,
    change: Function,
    errorCheck: Boolean,
  },
  data() {
    return this.initialState();
  },
  methods: {
    handleClick(e) {
      if (e.target.matches("a")) {
        let url = e.target.href;
        let target = e.target.target == "_blank" ? "_blank" : "_self";
        let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
        var isnativeapp = document.getElementById("isnativeapp");
        if (isnativeapp === undefined || isnativeapp === null) {
          window.open(url, target);
        } else {
          if (target == "_blank") {
            let data = { title: "", nodeid: dataId, href: url, target: target };
            window.Native("dataCallback", data);
          }
        }
      }
    },

    initialState() {
      return {
        switchType: false,
        cm: null,
        ft: null,
        inches: null,
        previousCm: null,
        heightMin: 140,
        heightMax: 190,
        heightNotValid: false,
      };
    },

    reset() {
      Object.assign(this.$data, this.initialState());
    },

    ftInToCm() {
      this.$emit("inputPress");
      setTimeout(() => {
        if (this.inches > 11) {
          this.inches = 11;
        }
        let feet = this.ft;
        let inches = this.inches;

        this.ft = parseFloat(parseFloat(feet).toFixed(0));
        this.inches = inches != null ? parseFloat(parseFloat(inches).toFixed(0)) : 0;

        let centermeters = Math.round(
          this.ft / 0.032808 + this.inches / 0.3937
        );
        this.setFtIn(this.ft, this.inches);
        this.setCm(centermeters);
        this.checkValue();
      }, 300);
      return;
    },

    cmToFtIn() {
      this.$emit("inputPress");
      setTimeout(() => {
        let currentCm = this.cm;
        this.cm = parseFloat(parseFloat(currentCm).toFixed(0));
        let convert = (this.cm * 0.3937) / 12;
        let feet = Math.floor(convert);
        let inches = Math.round((convert - feet) * 12);
        if (inches >= 12) {
          inches = 0;
          feet++;
        }
        this.setCm(this.cm);
        this.setFtIn(feet, inches);
        this.checkValue();
      }, 300);
      return;
    },

    setCm(cm) {
      setTimeout(() => {
        this.cm = parseFloat(parseFloat(cm).toFixed(0));
      }, 0);
      return;
    },

    setFtIn(ft, inches) {
      setTimeout(() => {
        console.log(inches);

        this.ft = parseFloat(parseFloat(ft).toFixed(0));
        if (this.inches > 11) {
          this.inches = 11;
        }
        else {
          this.inches = parseFloat(
            inches != null ? parseFloat(parseFloat(inches).toFixed(0)) : 0
          );
        }
        if (isNaN(this.inches) || this.inches == null && this.feet > 0) {
            this.inches = 0;
        }
      }, 0);
      return;
    },

    checkValue() {
      setTimeout(() => {
        if (
          (this.cm < this.heightMin || this.cm > this.heightMax) &&
          this.cm != ""
        ) {
          this.heightNotValid = true;
        } else {
          this.heightNotValid = false;
        }
      }, 0);
      return;
    },

    switchLayout() {
      this.switchType = !this.switchType;
    },
  },
};
</script>